import React from 'react';
import styles from './styles/layout.module.scss';
import NewSidebar from './NewSidebar';
import Header from './Header';

function Layout({ children, user, fi }) {
    return (
        <div className={styles.layout}>
            <div className={styles.contentWrapper}>
                <div className={styles.sidebarSlot}>
                    <NewSidebar user={user} fi={fi} />
                </div>
                <div className={styles.card}>
                    <Header user={user} fi={fi} />
                    <div className={styles.children}>{children}</div>
                </div>
            </div>
        </div>
    );
}

export default Layout;
